<template>
  <div class="breadcrumb">
    <div class="breadcrumb__width">
      <span class="breadcrumb__all">全部结果<i class="before-all"></i></span>
      <span class="breadcrumb__keyWord">{{ keyword }}</span>
      <template v-if="chooseSift && Object.keys(chooseSift).length > 0">
        <div
          class="breadcrumb__alreayFilter"
          v-for="(value, key, index) of chooseSift"
          :key="index"
        >
          <i class="before"></i>
          <p class="breadcrumb__breadcrumbItem">
            <span class="color-r middle">{{ siftName[key] }}：</span>
            <span class="color-r middle">{{ value.name }}</span>
            <span class="close-img middle" @click.prevent="closeItem(key, $event)">
            </span>
          </p>
        </div>
      </template>
    </div>
    <div class="absolute-item">
      <div
        class="breadcrumb__clean"
        @click="closeAll($event)"
        v-if="chooseSift && Object.keys(chooseSift).length > 0"
      >
        清除筛选条件
      </div>
      <div class="siftMore" @click="showMore()" v-if="typeList && typeList.length > 3">
        <span class="siftMore__text">{{ isShowMore ? '收起筛选' : '更多筛选' }}</span
        ><img
          src="//res11.xesimg.com/www/img/arrow-down.png"
          :class="{ rotate: isShowMore === true }"
        />
      </div>
    </div>
    <!-- <div class="breadcrumb__clean" @click="closeAll($event)" v-if="chooseSift && Object.keys(chooseSift).length > 0">清除筛选条件</div>
    <div class="siftMore" @click="showMore()" v-if="typeList && typeList.length > 3"><span class="siftMore__text">{{isShowMore ? '收起筛选' : '更多筛选'}}</span><img src="//res11.xesimg.com/www/img/arrow-down.png" :class="{rotate:isShowMore === true}"></div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      isShowMore: false
    }
  },
  watch: {
    keyword() {
      this.isShowMore = false
    }
  },
  computed: {
    ...mapState({
      chooseSift: state => state.SearchPage.chooseSift,
      siftName: state => state.SearchPage.siftName,
      dataExpTag: state => state.SearchPage.dataExpTag,
      searchSift: state => state.SearchPage.searchSift,
      nameSort: state => state.SearchPage.nameSort
    }),
    keyword() {
      const { keyword = '' } = this.$route.query
      return keyword
    },
    typeList() {
      if (
        this.searchSift &&
        this.searchSift.constructor === Object &&
        Object.keys(this.searchSift).length > 0
      ) {
        const typeArr = Object.keys(this.searchSift)
        const sortArr =
          this.nameSort &&
          this.nameSort.filter(item => {
            return typeArr.indexOf(item) > -1
          })
        return sortArr
      }
      return []
    },
    searchSiftLog() {
      let obj = Object.create(null)
      if (
        this.searchSift &&
        this.searchSift.constructor === Object &&
        Object.keys(this.searchSift).length > 0
      ) {
        let keysArr = Object.keys(this.searchSift)
        for (let item of keysArr) {
          let arr = this.searchSift[item].map(i => {
            return i.id
          })
          obj[item] = arr
        }
      }
      return obj
    },
    chooseSiftLog() {
      let obj = Object.create(null)
      for (let item in this.chooseSift) {
        obj[item] = this.chooseSift[item].id
      }
      return obj
    }
  },
  methods: {
    showMore() {
      this.isShowMore = !this.isShowMore
      // this.dispatch('siftConditions', 'showMore', this.isShowMore)
      this.$emit('handleShow')
    },
    // 清除所有筛选条件
    async closeAll(event) {
      const newQuery = Object.create(null)
      const { keyword = '', sort = 1 } = this.$route.query
      if (keyword) {
        newQuery.keyword = keyword
      }

      newQuery.sort = sort
      newQuery.flag = 2
      this.$router.push({
        name: this.$route.name,
        query: newQuery
      })
      this.xesLog(
        'click',
        {
          clickid: '1.4.31',
          key: `xeslog-search-closeAllSift`,
          choose_option: this.searchSift && this.searchSiftLog,
          choosed_option: this.chooseSiftLog
        },
        event
      )
    },
    deleteQuery(oldQuery, keyName) {
      const newObj = {}
      for (let key in oldQuery) {
        if (key !== keyName) {
          newObj[key] = oldQuery[key]
        }
      }
      return newObj
    },
    closeItem(item, event) {
      // 关闭面包屑某一项
      const { keyword = '', sort = 1 } = this.$route.query
      let newQuery = this.deleteQuery(this.chooseSift, item) // 将关闭的项从链接中删除
      newQuery = this.dealBreadFilItem(newQuery)
      this.$router.push({
        name: this.$route.name,
        query: { keyword, sort, ...newQuery, flag: 2 }
      })
      const clickIdTypes = {
        grades: '1.4.11',
        subjects: '1.4.12',
        difficulties: ' 1.4.13',
        terms: '1.4.14',
        timeTypes: '1.4.15',
        timeSlots: '1.4.16',
        liveTypeIds: '1.4.17',
        versions: '1.4.18',
        type: '1.4.9'
      }
      const itemClickId = clickIdTypes[item]
      this.xesLog(
        'click',
        { clickid: itemClickId, key: `xeslog-search-closeSift-${item}` },
        event
      )
    },
    dealBreadFilItem(obj) {
      if (obj) {
        const newObj = {}
        for (let key in obj) {
          newObj[key] = obj[key].id
        }
        return newObj
      }
      return null
    },
    xesLog(eventName, params, event) {
      const XESLog = new this.$XESLog({
        ...params,
        sorttype: this.$route.query.sort ? this.$route.query.sort : 1,
        setgradeid: this.$store.state.cookies.userGrade,
        curgradeid: this.$store.state.cookies.currentGrade,
        query: this.$route.query.keyword,
        exp_tag: this.dataExpTag
      })
      XESLog.push({ eventname: eventName, target: event.target }, this.$route)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
@include b(breadcrumb) {
  max-width: 100%;
  padding-bottom: 16px;
  position: relative;
  @include e(all) {
    color: #999999;
    display: inline-block;
    font-size: 12px;
    line-height: 22px;
    vertical-align: middle;
    margin-top: 16px;
  }
  @include e(keyWord) {
    margin-top: 16px;
    display: inline-block;
    height: 22px;
    line-height: 22px;
    vertical-align: middle;
  }
  @include e(alreayFilter) {
    display: inline-block;
    margin-top: 16px;
    vertical-align: middle;
  }
  .before {
    &::before {
      content: '>';
      display: inline-block;
      color: #666666;
      vertical-align: middle;
      padding: 0 5px;
    }
  }
  .before-all {
    &::before {
      content: '>';
      display: inline-block;
      color: #666666;
      padding: 0 5px;
    }
  }
  @include e(breadcrumbItem) {
    font-size: 12px;
    border: solid 1px #ddd;
    display: inline-block;
    margin: 0;
    color: #333;
    padding-left: 12px;
    .middle {
      display: inline-block;
      height: 20px;
      line-height: 20px;
      vertical-align: middle;
    }
    .close-img {
      background-image: url('../images/bread_close.png');
      background-size: 8px 8px;
      background-repeat: no-repeat;
      background-position: center;
      padding: 0 12px;
      vertical-align: middle;
    }
    // padding:4px 0 4px 12px;
    &:hover {
      cursor: pointer;
      border: solid 1px #f13232;
      // background-color: #fff;
    }
  }
  @include e(clean) {
    // position: absolute;
    // right: 0;
    // top: 15px;
    box-sizing: border-box;
    display: inline-block;
    font-size: 12px;
    border: solid 1px #cccccc;
    line-height: 20px;
    padding: 0 8px;
    cursor: pointer;
    vertical-align: middle;
    &:hover {
      color: #f13232;
    }
  }
}
.breadcrumb__width {
  max-width: 1000px;
}
.siftMore {
  display: inline-block;
  margin-left: 16px;
  width: 77px;
  height: 22px;
  font-size: 12px;
  border: solid 1px #cccccc;
  cursor: pointer;
  padding: 0 8px;
  box-sizing: border-box;
  &:hover {
    color: #f13232;
  }
  span {
    display: inline-block;
    vertical-align: middle;
    line-height: 20px;
  }
  img {
    display: inline-block;
    margin-left: 3px;
    vertical-align: middle;
    width: 8px;
    height: 5px;
    transition: all 0.2s;
  }
  .rotate {
    transform: rotate(180deg);
  }
}
.absolute-item {
  position: absolute;
  right: 0;
  top: 16px;
  color: #666666;
}
</style>



// WEBPACK FOOTER //
// ./src/views/SearchPage/components/SiftBreadcrumb.vue